import { PurchaseOrders } from '@/features/purchase-orders/purchase-orders';
import { AppLayout } from '@/layouts/app-layout';

export function PurchaseOrdersPage() {
  return (
    <AppLayout>
      <PurchaseOrders />
    </AppLayout>
  );
}
